<template>
  <div id="28_main">
    <v-row>
      <v-alert v-show="errorAlertShow" dense outlined type="error"><strong>Критична помилка! </strong>( {{errorMessage}} )</v-alert>
      <v-progress-linear v-show="progresLineShow" indeterminate fixed color="red"></v-progress-linear>
    </v-row>
    <v-row>
      <v-col cols="12" sm="3" md="3">
        <v-card>
          <v-treeview
          :items="itemsTree"
          :active.sync="active"
          dense
          activatable
          transition
          >
            <template v-slot:prepend="{ item, open }">
              <v-icon v-if="item.children">
                {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
              </v-icon>
            </template>
          </v-treeview>
        </v-card>
      </v-col>
      <v-col cols="12" sm="9" md="9">
        <v-simple-table dense>
        <template v-slot:default>
          <thead> 
            <tr>
              <th class="text-left">Артикул</th>
              <th class="text-left">ТМЦ</th>

            </tr>
          </thead>
          <tbody>
            <tr 
              v-for="item in itemsTmcList" :key="item.id" @click="dialogEditTmc(item.id)"
              v-bind:style="{ cursor: isHovered ? 'pointer' : 'default' }"
              v-on:mouseover="isHovered = true" v-on:mouseleave="isHovered = false"
            >
              <td>{{ item.article }}</td>
              <td>{{ item.name }}</td>
            </tr>
          </tbody>
        </template>
        </v-simple-table>
      </v-col>
    </v-row>

    <TmcDetailsDialog v-model="dialogTmcShow" :tmc="dialogTmcData" />
  </div>
</template>

<script>
import TmcDetailsDialog from './28_tmc_details_dialog.vue'
  export default {
    components: {
      TmcDetailsDialog
    },
    data: function () {
      return {
        errorMessage: '',
        errorAlertShow: false,
        progresLineShow: false,
        isHovered: false,
        itemsTree: [],
        active: [],
        itemsTmcList: [],
        dialogTmcShow: false,
        dialogTmcData: 0,
        
      }
    },
    watch: {
      selected: 'getItemsActiveGroup',
      
    },
    methods: {
      getTree(tab) {
        this.progresLineShow = true;
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            act: '9999',
            ww: '4',
            pp: localStorage.pp,
            pn: localStorage.pn,
            tab: tab,
          })
        };
        fetch(this.$store.getters.apiUrl, requestOptions)
          .then(async response => {
            const data = await response.json();
            if (!response.ok) {
              const error = (data && data.message) || response.status;
              return Promise.reject(error);
            }
            this.itemsTree = data;
            this.progresLineShow = false;
          })
          .catch(error => {
            this.errorMessage = error;
            this.progresLineShow = false;
            this.errorAlertShow = true;
          });

      },
      getItemsActiveGroup() {
        this.progresLineShow = true;
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            act: '28',
            ww: '1',
            pp: localStorage.pp,
            pn: localStorage.pn,
            tab: this.active[0],
          })
        };
        fetch(this.$store.getters.apiUrl, requestOptions)
        .then((data) => {
          if (!data.ok) {
            const error = (data && data.message) || data.status
            return Promise.reject(error)
          }
          return data
        })
        .then((data) => data.json())
        .then((data) => {
          if (data.isauth == true) {
            this.progresLineShow = false
            this.itemsTmcList = data.tmclist
          }
          if (data.isauth == false) {
            this.$router.push('/login').catch(()=>{})
          }
        })
        .catch(error => {
          this.errorMessage = error
          this.progresLineShow = false
          this.errorAlertShow = true
        });
         
      },
      dialogEditTmc(item) {
        this.dialogTmcShow = true
        this.dialogTmcData = item
        
      }
      

    },
    computed: {
      selected () {
        if (!this.active.length) return undefined
        const id = this.active[0]
        return id
      },
      
    },
    created: function () {
      this.getTree(0)

    },
  }
</script>